import { tryExecute } from 'framework/error_handling/error-utils';
import { ServiceBase } from 'support/base_classes/service-base';
import * as E from 'support/errors';

export async function requireServices(...services: ServiceBase[]) {
  await tryExecute(() => Promise.all(services.map(s => s.ready)), E.SCREEN_UNAVAILABLE_MESSAGE, E.SCREEN_UNAVAILABLE_TITLE, false);
}
